import _ from 'lodash'
import Vue from 'vue'

export class TooManyRecordsFound extends Error {}
export class NoRecordFound extends Error {}

export class SingleQueryResult {
    constructor() {
        this._key = undefined
        this._value = undefined
    }

    get isEmpty() {
        return this._key === undefined
    }

    get value() {
        return this._value
    }

    set value(v) {
        this._value = v
    }

    get key() {
        return this._key
    }

    set key(k) {
        this._key = k
    }

    get singleValue() {
        return _.get(this.value, 'value.value', undefined)
    }

    set singleValue(value) {
        Vue.set(this.value.value, 'value', value)
    }
}


export default class PropertyQuery {
    constructor(store) {
        this.$store = store
    }

    many(propertyTypes, {tag, key}) {
        console.info(propertyTypes, tag, key)
        return []
    }

    // onePropertyByTag(task, tag) {
    //     const result = new SingleQueryResult()
    //     _.each(task.propertyValues, (pv, key) => {
    //         const pt = this.$store.getters.propertyTypeByKey(key)
    //         const tags = _.get(pt, 'settings.systags', [])
    //         const hasTag = _.get(tags, tag, false)
    //         if (hasTag) {
    //             result.key = key
    //             result.value = pv
    //         }
    //     })
    //     if (result.isEmpty) {
    //         throw new NoRecordFound()
    //     } else {
    //         return result
    //     }
    // }
}
